var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-typography-root cms-rich-text",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.richText))}})
}
var staticRenderFns = []

export { render, staticRenderFns }